/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_EInputs */

const en_subtitle_export_program_e = /** @type {(inputs: Subtitle_Export_Program_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program E`)
};

const fr_subtitle_export_program_e = /** @type {(inputs: Subtitle_Export_Program_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme E`)
};

const de_subtitle_export_program_e = /** @type {(inputs: Subtitle_Export_Program_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programm E`)
};

const it_subtitle_export_program_e = /** @type {(inputs: Subtitle_Export_Program_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programma E`)
};

const ru_subtitle_export_program_e = /** @type {(inputs: Subtitle_Export_Program_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Программа Е`)
};

const es_subtitle_export_program_e = /** @type {(inputs: Subtitle_Export_Program_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa E`)
};

const zh_cn2_subtitle_export_program_e = /** @type {(inputs: Subtitle_Export_Program_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`程序 E`)
};

const ja_subtitle_export_program_e = /** @type {(inputs: Subtitle_Export_Program_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラムE`)
};

const hi_subtitle_export_program_e = /** @type {(inputs: Subtitle_Export_Program_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम ई`)
};

const pt_pt2_subtitle_export_program_e = /** @type {(inputs: Subtitle_Export_Program_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa E`)
};

/**
* | output |
* | --- |
* | "Program E" |
*
* @param {Subtitle_Export_Program_EInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_e = /** @type {((inputs?: Subtitle_Export_Program_EInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_EInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_program_e(inputs)
	if (locale === "de") return de_subtitle_export_program_e(inputs)
	if (locale === "it") return it_subtitle_export_program_e(inputs)
	if (locale === "ru") return ru_subtitle_export_program_e(inputs)
	if (locale === "es") return es_subtitle_export_program_e(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_program_e(inputs)
	if (locale === "ja") return ja_subtitle_export_program_e(inputs)
	if (locale === "hi") return hi_subtitle_export_program_e(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_program_e(inputs)
	return en_subtitle_export_program_e(inputs)
});